import { render, staticRenderFns } from "./Title_EmailTemplate.vue?vue&type=template&id=6c6a2bc2&scoped=true&"
import script from "./Title_EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./Title_EmailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a2bc2",
  null
  
)

export default component.exports